import EmptyState from '@/components/ui/EmptyState'
import Toggle from '@/components/ui/Toggle'
import {
  useNewsletterSubscription,
  useSetNewsletterSubscription,
} from '@/features/newsletter/api/queries'
import { NEWSLETTER_SUBSCRIPTION_AVAILABLE } from '@/features/newsletter/api/subscriptionService'
import MascotMark from '@/features/newsletter/components/MascotMark'

/**
 * "Get new issues": the bell mark, the pitch, and the switch (the mock's `nl-sub` row, 52 tall).
 *
 * mm-be has no subscribe endpoint, so `NEWSLETTER_SUBSCRIPTION_AVAILABLE` is `false`: the row draws
 * as the mock does, the switch held off and disabled, with the generic "Not available yet" under it,
 * and no request is made. The contract is in `asks/nw2.md`.
 */
export default function GetNewIssuesRow() {
  const subscription = useNewsletterSubscription()
  const setSubscription = useSetNewsletterSubscription()
  const checked = subscription.data ?? false

  return (
    <div className="rounded-lg border border-border-subtle bg-card">
      <div className="flex items-center gap-3 px-3 py-2">
        <MascotMark variant="notify" size={28} />
        <div className="min-w-0 flex-1">
          <p className="text-body-m text-foreground">Get new issues</p>
          <p className="text-body-xs text-muted-foreground-subtle">
            One issue every Sunday morning
          </p>
        </div>
        <Toggle
          aria-label="Get new issues"
          checked={checked}
          disabled={!NEWSLETTER_SUBSCRIPTION_AVAILABLE || subscription.isPending}
          onCheckedChange={(next) => {
            setSubscription.mutate(next)
          }}
        />
      </div>
      {NEWSLETTER_SUBSCRIPTION_AVAILABLE ? null : (
        <div className="border-t border-border-subtle px-3 py-2">
          <EmptyState kind="not-available" thing="New-issue alerts" size="inline" />
        </div>
      )}
    </div>
  )
}
